import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/vi';
import viTranslations from '../lang/vi.json';
import enTranslations from '../lang/en.json';

const applyMomentLocale = (language) => {
  moment.locale(language === 'vi' ? 'vi' : 'en');
};

/** Resolve UI language from storage; default English when unset. */
const resolveInitialLanguage = () => {
  try {
    return (
      sessionStorage.getItem('ced:session-language') ||
      localStorage.getItem('ced:language') ||
      'en'
    );
  } catch (e) {
    return 'en';
  }
};

const setupI18n = async (defaultLanguage = 'en') => {
  await i18next.use(initReactI18next).init({
    lng: defaultLanguage,
    fallbackLng: false,
    resources: {
      vi: {
        translation: viTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });
  applyMomentLocale(defaultLanguage);
};

const setLanguage = async (language) => {
  if (!language) {
    language = 'en'; // Mặc định là tiếng Anh
  }
  await i18next.changeLanguage(language);
  applyMomentLocale(language);
  // Không tự động lưu vào localStorage ở đây
  // Chỉ lưu khi user đã đăng nhập và chủ động đổi ngôn ngữ trong NavLanguage
};

/** BCP-47 locale for react-calendar / Intl — read at call time (not module load). */
const getDateLocaleCode = () => (i18next.language === 'vi' ? 'vi-VN' : 'en-US');

/** Display name of vi/en in the current UI language — read at call time. */
const getLanguageDisplayLabel = (code) =>
  i18next.t(code === 'en' ? 'language_name_en' : 'language_name_vi');

setupI18n(resolveInitialLanguage());

export {
  i18next as I18n,
  setLanguage,
  getDateLocaleCode,
  getLanguageDisplayLabel,
  resolveInitialLanguage,
};
